// extracted by mini-css-extract-plugin
export default {"form":"PersonalAccountForm_form__n84rl"};